export default __webpack_public_path__ + "static/media/blue-up-arrow.e1263e20.svg";